<template>
  <div>
    <heads :msg="title_msg" :states="1"></heads>
    <div v-if="giftSuccess">
      <div class="banner">
        <img class="bannerImg" :src="banner_image" alt="">
      </div>
      <div v-show="gift_source === 1">
        <!-- 原创 -->
        <div class="title">
          <p>{{ obj.quantity }}</p>
          <p>{{ obj.gift_name }}</p>
          <p>{{ introduce }}</p>
          <img src="@/static/ucenter-qie/mon.png" alt="">
        </div>
        <div class="detailImg">
          <div class="detailImgTitle">
            <p>商品介绍</p>
          </div>
          <div style="padding-bottom:80px;">
            <img v-for="(item,index) in content" :key="index" class="imgsq" :src="item" alt="">
          </div>
        </div>
      </div>
      <div v-show="gift_source === 2">
        <!-- 京东 -->
        <div class="jd_title">
          <p>{{ obj.quantity }}</p>
          <p>{{ obj.gift_name }}</p>
          <div style="padding:10px 20px 0 15px;font-size:15px;" v-html="jd_param"></div>
          <img src="@/static/ucenter-qie/mon.png" alt="">
        </div>
        <div class="detailImg">
          <div class="detailImgTitle">
            <p>商品介绍</p>
          </div>
          <div class="jd_style" style="margin-bottom:80px;" v-html="jd_introduction"></div>
          <!-- <div style="margin-bottom:80px;">
          <img v-for="(item,index) in content" :key="index" class="imgsq" :src="item" alt="">
        </div> -->
        </div>
      </div>
      <div class="myFoot">
        <div class="price">
          <img src="@/static/ucenter-qie/mon.png" alt="">
          <p>{{ obj.quantity }}</p>
        </div>
        <div class="immediatelyExchange">
          <button @click="RedeemNow()">立即兑换</button>
        </div>
      </div>
    </div>
    <div v-else class="nodatas">
      <img src="@/assets/new_kong.png" alt="kong">
      <p>{{ errorMsg }}</p>
    </div>
  </div>
</template>

<script>
// import heads from '@/components/heads.vue'
import { get_giftDetail, getMyScore } from '@/api/giftIndex.js'
import { getAppCommonStatis } from '@/api/hometop.js'
import { Toast } from 'vant'
export default {
  components: {
    // heads

  },
  data() {
    return {
      giftSuccess: false,
      errorMsg: '',
      title_msg: '礼品详情',
      obj: {},
      introduce: '',
      content: [],
      gift_source: 1, // 区分京东还是原创  1是原创 2是京东
      banner_image: '',
      jd_introduction: '',
      jd_param: '',
      moneyName: ''
    }
  },
  mounted() {
    this.$store.dispatch('getName').then(() => {
      this.moneyName = this.$store.state.getRow.scoreName
    })
    this.get_msg()
    this.getAppCommonStatis()
  },
  methods: {
    RedeemNow(index) {
      getMyScore().then(res => {
        if (res.result >= this.obj.quantity) {
          this.$router.push({
            path: '/gift/giftexchange_jdyx',
            query: {
              id: this.$route.query.id
            }
          })
        } else {
          const msg = this.moneyName + '不足'
          Toast(msg)
        }
      })
    },
    get_msg() {
      var params = {
        id: this.$route.query.id
      }
      get_giftDetail(params).then(res => {
        const errNo = res.errNo
        const result = res.result
        if (errNo === 0 && result.gift_source) {
          this.giftSuccess = true
          this.obj = result
          this.gift_source = this.obj.gift_source
          if (this.gift_source === 2) {
            // this.banner_image = 'http://img13.360buyimg.com/n12/' + this.obj.img
            this.banner_image = this.obj.img
            this.jd_introduction = this.obj.info.introduction
            this.jd_param = this.obj.info.param
          } else {
            this.banner_image = this.obj.img
            this.introduce = res.result.info.introduce
            this.content = res.result.info.content
          }
        } else {
          this.giftSuccess = false
          const msg = '该商品不存在或已下架~'
          if (typeof (res.result) === 'string') {
            msg = res.result
          }
          this.errorMsg = msg
          this.$toast(msg)
        }
      })
    },
    // 三方统计
    getAppCommonStatis() {
      getAppCommonStatis().then(res => {
        console.log(res, 'res')
        this.statis = res.result
        var bd_script = document.createElement('script')
        bd_script.type = 'text/javascript'
        // bd_script.innerHTML = this.statis.baidu_h5
        // console.log(this.statis, 'this.statis')
        document.head.appendChild(bd_script)
        var cc_script = document.createElement('script')
        cc_script.type = 'text/javascript'
        if (this.statis){
            cc_script.innerHTML = this.statis.circle
        }
        document.head.appendChild(cc_script)
        var cz_script = document.createElement('script')
        cz_script.type = 'text/javascript'
        cz_script.src = 'https://s4.cnzz.com/z_stat.php?id=5078536&web_id=5078536'
        // cz_script.innerHTML = this.statis.cnzz
        document.head.appendChild(cz_script)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detailImgTitle {
  font-size: 30px;
  // font-weight: 600;
  color: #444444;
  text-align: center;
  padding: 59px 0 52px 0;
}
.myFoot {
  width: 300px;
  height: 100px;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
}
.imgsq {
  width: 100%;
}
.myFoot .price img {
  position: absolute;
  width: 41px;
  height: 40px;
  left: 31px;
  // top: 28px;
  top: 23px;
}
.myFoot .price p {
  margin: 0 auto;
  line-height: 90px;
  width: 285px;
  // height: 37px;
  // font-size: 48px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ee2e2f;
}
.myFoot .price {
  width: 450px;
  height: 100px;
  background: #fff;
}
.immediatelyExchange button {
  width: 300px;
  height: 100px;
  background: #ee2e2f;
  color: #fff;
  font-size: 32px;
}
.myFoot {
  width: 100%;
  height: 100px;
}
.detailImg {
  width: 100%;
}
.banner {
  width: 100%;
  height: 401px;
}
.bannerImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  // background: antiquewhite;
}
.title {
  position: relative;
  width: 100%;
  height: 326px;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.06);
}
.title img {
  width: 41px;
  height: 40px;
  position: absolute;
  left: 29px;
  // top: 25px;
  top: 28px;
}
.title p:nth-child(1) {
  width: 104px;
  // height: 34px;
  // font-size: 44px;
  // line-height: 53px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ee2e2f;
  padding: 25px 0 0 84px;
}
.title p:nth-child(2) {
  width: 645px;
  // font-size: 36px;
  // font-weight: 600;
  font-size: 30px;
  color: #222222;
  padding: 30px 0 0 0;
  margin: 0 0 0 25px;
}
.title p:nth-child(3) {
  width: 662px;
  height: 64px;
  // font-size: 24px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #888888;
  line-height: 41px;
  padding: 15px 0 0 25px;
}

.jd_title {
  position: relative;
  width: 100%;
  // height: 326px;
  padding-bottom: 20px;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.06);
}
.jd_title img {
  width: 41px;
  height: 40px;
  position: absolute;
  left: 29px;
  top: 28px;
}
.jd_title p:nth-child(1) {
  width: 104px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ee2e2f;
  padding: 25px 0 0 84px;
}
.jd_title p:nth-child(2) {
  width: 645px;
  font-size: 30px;
  color: #222222;
  padding: 30px 0 0 0;
  margin: 0 0 0 25px;
}
.jd_title p:nth-child(3) {
  width: 662px;
  // height: 64px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #888888;
  line-height: 41px;
  padding: 15px 0 0 25px;
}
.jd_style {
  padding-bottom: 100px;
  /deep/img {
    width: 100%;
  }
  /deep/div {
    width: 100%;
  }
}
/deep/ .ssd-module-wrap div {
  // background-size: 100% 51% !important;
  // height: 1500px;
  overflow: hidden;
}
.nodatas {
  margin-top: 250px;
  text-align: center;
  p {
    color: #333;
    font-size: 26px;
    margin-top: 20px;
  }
}
button{
  outline: none;
  border:0;
}
</style>
